class PropertiesController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

    edit() {
        propertiesOnEditOrNew();
    }

    new() {
        propertiesOnEditOrNew();
    }

    show() {
        onShowOrMoving();
    }

    moving() {
        onShowOrMoving();
    }
}

window.BC = window.BC || {};
window.BC.properties = new PropertiesController();

let geocoder, map;

function initalizeMap() {
    let latlng = new google.maps.LatLng(47.6097, 122.3331);
    geocoder = new google.maps.Geocoder();
    let myOptions = {
        zoom: 15,
        center: latlng,
        mapTypeId: google.maps.MapTypeId.SATELLITE
    };
    const mapCanvas = document.getElementById('map_canvas');
    if (mapCanvas) {
        map = new google.maps.Map(mapCanvas, myOptions);
    }
}

function centerMap(address) {
    geocoder.geocode({
        address: address
    }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
            map.setCenter(results[0].geometry.location);
            let marker = new google.maps.Marker({
                map: map,
                position: results[0].geometry.location
            });
        } else {
            alert("Geocode was not successful for the following reason: " + status);
        }
    });
}

function navigate(lng, lat) {
    function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            let v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [
                parseInt(v[1], 10),
                parseInt(v[2], 10),
                parseInt(v[3] || 0, 10)
            ];
        }
        return null;
    }

    if (navigator.platform.indexOf('iPhone') !== -1 || navigator.platform.indexOf('iPod') !== -1) {
        let ver = iOSversion() || [0];
        let protocol;
        if (ver[0] >= 6) {
            protocol = 'maps://';
        } else {
            protocol = 'http://';
        }
        window.location = protocol + 'maps.apple.com/maps?daddr=' + lat + ',' + lng + '&amp;ll=';
    } else {
        window.open('http://maps.google.com?daddr=' + lat + ',' + lng + '&amp;ll=');
    }
}

function navigateByAddress(address) {
    function iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            let v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [
                parseInt(v[1], 10),
                parseInt(v[2], 10),
                parseInt(v[3] || 0, 10)
            ];
        }
        return null;
    }

    if (navigator.platform.indexOf('iPhone') !== -1 || navigator.platform.indexOf('iPod') !== -1) {
        let ver = iOSversion() || [0];
        let protocol;
        if (ver[0] >= 6) {
            protocol = 'maps://';
        } else {
            protocol = 'http://';
        }
        window.location = protocol + 'maps.apple.com/maps?daddr=' + address;
    } else {
        window.open('http://maps.google.com?daddr=' + address);
    }
}

function propertiesOnEditOrNew() {
    // REPLACED: TokenInput replaced with Tom Select Stimulus controller
    // Token fields now use data-controller="tom-select" in the HTML
    
    // Handle property square footage formatting
    const propertySfField = document.getElementById('property_sf');
    if (propertySfField) {
        propertySfField.addEventListener('blur', function() {
            this.value = NumberHelpers.number_with_delimiter(this.value.replace(/[^\d.-]/g, ''), {precision: 0});
        });
    }
    
    // Handle lot square footage formatting
    const propertyLotSfField = document.getElementById('property_lotsf');
    if (propertyLotSfField) {
        propertyLotSfField.addEventListener('blur', function() {
            this.value = NumberHelpers.number_with_delimiter(this.value.replace(/[^\d.-]/g, ''), {precision: 0});
        });
    }
    
    // Handle beds formatting
    const propertyBedsField = document.getElementById('property_beds');
    if (propertyBedsField) {
        propertyBedsField.addEventListener('blur', function() {
            this.value = this.value.replace(/[^\d.-]/g, '');
        });
    }
    
    // Handle baths formatting
    const propertyBathsField = document.getElementById('property_baths');
    if (propertyBathsField) {
        propertyBathsField.addEventListener('blur', function() {
            this.value = NumberHelpers.number_with_precision(this.value.replace(/[^\d.-]/g, ''), {precision: 2});
        });
    }
    
    // Handle taxes formatting
    const propertyTaxesField = document.getElementById('property_taxes');
    if (propertyTaxesField) {
        propertyTaxesField.addEventListener('blur', function() {
            this.value = NumberHelpers.number_to_currency(this.value.replace(/[^\d.-]/g, ''), {precision: 0});
        });
    }
    
    // File upload functionality removed - no longer needed for properties
    
    // Image cropping functionality has been removed
    
    // Prevent default drag/drop behavior
    document.addEventListener('drop', function(e) {
        e.preventDefault();
    });
    document.addEventListener('dragover', function(e) {
        e.preventDefault();
    });
    
    // Handle document form changes
    document.addEventListener('change', function(event) {
        if (event.target.matches('.documentName, .client-can-see, .office-can-see, .escrow-can-see, .lender-can-see')) {
            const form = event.target.closest('form');
            if (form) {
                form.submit();
            }
        }
    });
}

// Image cropping functionality has been removed

function onShowOrMoving() {
    initalizeMap();
    const mapCanvas = document.getElementById('map_canvas');
    if (mapCanvas) {
        const address = mapCanvas.getAttribute('data-address');
        if (address) {
            centerMap(address);
        }
    }
}